import React, { FC } from 'react';
import styled from 'styled-components';

export type Props = {
  label: string;
  value: string;
  link?: { url: string; name: string };
};

const StaticField: FC<Props> = ({ label, value, link }) => {
  return (
    <FieldWrapper>
      <Label>{label}</Label>
      {link ? (
        <LinkValue href={link.url} target="_blank" rel="noreferrer">
          {link.name}
        </LinkValue>
      ) : (
        <Value>{value || '—'}</Value>
      )}
    </FieldWrapper>
  );
};

export default StaticField;

const FieldWrapper = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif;
  font-size: 0.875rem;
  color: var(--mainText);
  flex-wrap: wrap;
`;

const Label = styled.span`
  font-weight: 700;
  color: var(--neutral-700);
`;

const Value = styled.span`
  color: var(--mainText);
`;

const LinkValue = styled.a`
  color: var(--primary-600);
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover,
  &:visited,
  &:focus {
    color: var(--primary-700);
    text-decoration: underline;
  }
`;
